import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Zap icon component for the Automation Task action type in selectors and lists.
 */
import { Zap } from "lucide-react";
/**
 * Icon component for the automation task step type.
 * @param root0 - The component props
 * @param root0.className - CSS class name for styling
 * @returns The Zap icon from lucide-react
 */
export function Icon({ className }) {
    return _jsx(Zap, { className: className });
}
//# sourceMappingURL=Icon.js.map